import { useMutation } from '@apollo/client';

import { ProviderPlanId } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { CurrentPricingPlanDocument } from 'common/hooks/useCurrentPricingPlan/useCurrentPricingPlanQuery';

import { SwitchToPlanUpgradeInsuranceTermsAndConditionDocument } from './graphql/switchToPlanUpgradeInsuranceTermsAndCondition.gql';

const useSwitchToPlan = (providerPlanId: ProviderPlanId) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useUpgradeQuery');
  }

  return useMutation(SwitchToPlanUpgradeInsuranceTermsAndConditionDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: CurrentPricingPlanDocument,
        variables: { companyProfileId },
      },
    ],
    variables: {
      input: {
        companyProfileId,
        providerPlanId,
      },
    },
  });
};

export default useSwitchToPlan;
